/**
 * CyberSells Core - Main initialization & auto-start
 * This file loads after all modules and starts the gamification system
 */

(function() {
  'use strict';

  // Wait for all modules to load
  function waitForModules(callback, maxAttempts = 50) {
    let attempts = 0;
    
    const check = setInterval(() => {
      attempts++;
      
      // Check if core modules are loaded
      const modulesReady = 
        window.CyberSells_playerData &&
        window.CyberSells_stats &&
        window.CyberSells_achievements &&
        window.CyberSells_toast;
      
      if (modulesReady) {
        clearInterval(check);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        console.warn('[CyberSells] Modules failed to load within timeout');
      }
    }, 100);
  }

  // Initialize CyberSells when DOM and modules are ready
  function initCyberSells() {
    console.log('[CyberSells] Starting initialization...');
    
    // Create CyberSells instance using the class from cybersells/core.js
    if (!window.CyberSells) {
      console.error('[CyberSells] CyberSells class not found');
      return;
    }
    
    const config = window.cyberSellsConfig || {};
    const cs = new window.CyberSells(config);
    
    // Initialize
    cs.init();
    
    // Make instance globally available
    window.cyberSells = cs;
    
    // Auto-track product views on product pages
    if (document.body.classList.contains('template-product')) {
      const productId = document.querySelector('[data-product-id]')?.dataset.productId;
      const productTitle = document.querySelector('[data-product-title]')?.textContent;
      
      if (productId && window.CyberSells_purchaseHandler) {
        window.CyberSells_purchaseHandler.trackProductView(productId, productTitle);
      }
    }
    
    // Listen for Shopify cart events
    document.addEventListener('cart:updated', (event) => {
      console.log('[CyberSells] Cart updated', event.detail);
    });
    
    // Listen for add-to-cart
    document.addEventListener('cart:add', () => {
      if (window.CyberSells_purchaseHandler) {
        window.CyberSells_purchaseHandler.trackCartAdd();
      }
    });
    
    console.log('[CyberSells] Fully initialized and ready! ??');
  }

  // Start when DOM is ready (use { once: true } to prevent double initialization)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForModules(initCyberSells);
    }, { once: true });
  } else {
    waitForModules(initCyberSells);
  }

})();
